/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { ThumbsDownFilledIcon, ThumbsDownIcon } from '@coursera/cds-icons';

import type { CmlContent } from 'bundles/cml';
import LikeContent from 'bundles/content-feedback/components/like/LikeContent';
import type { ItemType } from 'bundles/content-feedback/constants/ItemTypes';

import _t from 'i18n!nls/content-feedback';

type Props = {
  selected: boolean;
  tooltipPlacement: string;

  onDeselect: () => void;
  onSelect: (cml: CmlContent) => void;

  comment: any;
  itemFeedbackType: ItemType;
};

const Dislike: React.FC<Props> = (props) => {
  const { selected } = props;

  return (
    <div
      css={css`
        margin-right: var(--cds-spacing-200);
      `}
      data-testid="dislike-button"
    >
      <LikeContent {...props}>
        <Button
          variant="ghost"
          size="small"
          aria-pressed={selected}
          icon={selected ? <ThumbsDownFilledIcon color="interactive" /> : <ThumbsDownIcon color="interactive" />}
          iconPosition="before"
        >
          {_t('Dislike')}
        </Button>
      </LikeContent>
    </div>
  );
};

export default Dislike;
